import React, { useState, useContext } from 'react';
import { Modal } from 'react-bootstrap';
import { LabelText } from '../../Language';
import CustomOverlayTrigger from '../../../hoc/CustomOverlayTrigger';
import { changeRequestTooltip } from '../../../components/UI/Tooltip/Tooltip';
import './PendingCrSuccess.css';
import { Link } from 'react-router-dom';
import { LanguageContext } from '../../../containers/Language/LanguageProvider';

const PendingCrSuccess = (props) => {
    const [show, setShow] = useState(true);
    const handleClosePopup = () => {
        setShow(false);
        props.setShowUnblockModel();
    };

    const { language } = useContext(LanguageContext);
    let gotocr;
    const gotochangerequest = () => {
        if (language.id === "1") {
            gotocr = "pending-go-toCR_EN";
        }
        else if (language.id === "2") {
            gotocr = "pending-go-toCR_FR";
        }
        else if (language.id === "3") {
            gotocr = "pending-go-toCR_NL";
        }
        else if (language.id === "4") {
            gotocr = "pending-go-toCR_DE";
        }
    }
    gotochangerequest();
    return (
        <div className="PendingCrSuccess-Modal-container">
            <Modal dialogClassName={"Model-dialoguebox"} show={show}
                onHide={handleClosePopup}
                backdrop="static"
                keyboard={true}
                scrollable={true}>
                {
                    <Modal.Header closeButton={true}
                        className="Bulk-Modal-header"
                        style={{ backgroundColor: '#25336C',color:'white' }} >
                        <div className="Image-Container" >
                            <div className={"InfoSquare"}></div>
                        </div>
                    </Modal.Header>
                }
                <Modal.Body>
                    <div className="Bulk-processing-body">
                        {
                            <div className="PendingCrSuccess-BusinessPartner-label-period">
                                <div className="PendingCrSucess-Line1"><LabelText tid="attention" /></div>
                                <br/>
                                <div className="PendingCrSucess-Line2"><LabelText tid="pendingcrmessage" value={props.pendingCrCount} /></div>
                            </div>
                        }
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className="PendingCrSuccess-Button-Container">
                        <div>
                            <div className="PendingCrSuccess-Request-Btn-Container">
                                <CustomOverlayTrigger placement="left" tooltip={changeRequestTooltip("continue")}>
                                    <div className={gotocr} role={"button"} tabIndex={0}
                                        onClick={handleClosePopup}
                                    ><LabelText tid="continue" /></div>
                                </CustomOverlayTrigger>
                            </div>
                            <div className="PendingCrSuccess-Request-Btn-Container">
                                    <Link to="/changerequest">
                                        <div className={gotocr} role={"button"} tabIndex={0}
                                             onClick={handleClosePopup} 
                                        ><LabelText tid="gotocr" /></div>
                                    </Link>
                            </div>
                        </div>
                    </div>
                </Modal.Footer>
            </Modal>
        </div>
    )
};

export default PendingCrSuccess;